import React from 'react';
import VideoSlider from './components/VideoSlider';

function App() {
  return (
    <div className="App h-full w-full">
      <VideoSlider />
    </div>
  );
}

export default App;
